import $ from './jq';
export const events = {
  canClick: true,
  isPlaying: true,
  userPlayState: true,
  isHeroHide: true,
  init() {
    this.fullPageInit();
    this.bindEvent();
    this.videoControl();
  },
  fullPageInit() {
    this.fullpage = new fullpage('#fullpage', {
      licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
      normalScrollElements: '.content-wrap',
      scrollingSpeed: 1500,
      onLeave: async function (origin, destination, direction) {
        let to = destination.index + 1;
        let from = origin.index + 1;
        to === 1 && $('.sidebar').removeClass('sidebar-show');
        from === 1 && $('.sidebar').addClass('sidebar-show');
        to === 3 && events.showStory();
        from === 3 && events.clearStory();
        to === 4 && events.showHero();
        from === 4 && events.hideHero();
        $('.j-nav a')
          .removeClass('active')
          .eq(to - 1)
          .addClass('active');
        $(`.section-${from}`).addClass('show_water mask');
        $(`.section-${to}`).addClass('lastPage');
        timer && clearTimeout(timer);
        let timer = setTimeout(() => {
          $(`.section-${from}`).removeClass('show_water mask nextPage');
          $(`.section-${to}`).removeClass('lastPage').addClass('nextPage');
          events.canClick = true;
        }, 1200);
      },
    });
    // fullpage_api.setScrollingSpeed(1000);
    /*导航定位*/
    $('.j-nav').on('click', ({ target }) => {
      if (!target.dataset.index || !events.canClick) {
        return;
      }
      const index = ~~target.dataset.index;
      $('.j-nav a').removeClass('active').eq(index).addClass('active');
      this.fullpage.moveTo(index + 1);
      events.canClick = false;
    });

    $('.j-scroll-btn').on('click', () => {
      this.fullpage.moveTo(2);
    });
  },
  videoControl() {
    $('#j-video-in')[0].addEventListener(
      'ended',
      function () {
        $('#j-video-in').hide();
        $('#j-video-loop').show();
        $('.pre').show(800);
      },
      false
    );
  },
  /*世界观动画初始化*/
  showStory() {
    $('.j-battle').addClass('active');
    $('.section-3 .inside-cloud').addClass('active');
    $('.section-3 .outside-cloud').addClass('active');
    this.timerArr &&
      this.timerArr.forEach(item => {
        clearTimeout(item);
      });
    this.timerArr = [];
    $('.j-content p')
      .show(100)
      .each((i, e) => {
        const timer = setTimeout(() => {
          $(e).addClass('active');
        }, 600 * i);
        this.timerArr.push(timer);
      });
  },
  clearStory() {
    $('.j-battle').removeClass('active');
      $('.section-3 .inside-cloud').removeClass('active');
      $('.section-3 .outside-cloud').removeClass('active');
    this.timerArr &&
      this.timerArr.forEach(item => {
        clearTimeout(item);
      });
    $('.j-content p').hide(3000).removeClass('active');
  },
  /*英雄动画初始化*/
  showHero() {
    $('.sidebar').removeClass('sidebar-show');
    $('.section-4 .cloud').addClass('active');
    $('.swiper-slide-active i').removeClass('active').addClass('active');
  },
  hideHero() {
    $('.sidebar').addClass('sidebar-show');
    $('.section-4 .cloud').removeClass('active');
    $('.swiper-slide-active i').removeClass('active');
  },
  bindEvent() {
    $('body').one('click', function () {
        $('.j-music-audio')[0].play();
    })
    $('.j-music-btn').on('click', function () {
      if (events.isPlaying) {
        $('.j-music-audio')[0].pause();
        $('.j-music-btn').html('OFF');
        events.isPlaying = false;
        events.userPlayState = false;
      } else {
        $('.j-music-audio')[0].play();
        $('.j-music-btn').html('ON');
        events.isPlaying = true;
        events.userPlayState = true;
      }
    });
  },
};
export default events;
